module.exports = __webpack_public_path__ + "static/media/sound2.22400a56.mp3";